import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=c58ee6e4&scoped=true&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"
import style0 from "./tabs.vue?vue&type=style&index=0&id=c58ee6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58ee6e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c58ee6e4')) {
      api.createRecord('c58ee6e4', component.options)
    } else {
      api.reload('c58ee6e4', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=c58ee6e4&scoped=true&", function () {
      api.rerender('c58ee6e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabs.vue"
export default component.exports